import logo from "../../../assets/images/svg/logo.png";
import condolenceLogo from "../../../assets/images/svg/condolenceLogo.svg";
import { lazy } from "react";
import { getWebEnvConfig } from "../../../scripts/helpers";

const AbrLogo = lazy(() => import("../../../assets/images/svg/logo.svg").then((log) => ({ default: log.ReactComponent })));
const CondolenceAbrLogo = lazy(() => import("../../../assets/images/svg/condolenceLogo.svg").then((log) => ({ default: log.ReactComponent })));

const LogoWithName = (props: { png?: boolean }) => {
    const handleGetLogo = () => {
        if (getWebEnvConfig("condolence") === "true") {
            if (!props.png) {
                return <CondolenceAbrLogo />;
            } else {
                return <img src={condolenceLogo} alt="logo" className="w-[145px] h-[25px]" />;
            }
        } else {
            if (!props.png) {
                return <AbrLogo />;
            } else {
                return <img src={logo} alt="logo" className="w-[145px] h-[25px]" />;
            }
        }
    };

    return handleGetLogo();
};

export default LogoWithName;
